import { useQuery } from '@tanstack/react-query';

import { getOfferingDividends } from '@arrived/api_v2';
import { OfferingDividend, OfferingId } from '@arrived/models';

import { MAX_STALE_TIME, UseQueryOptions, UseQueryResult } from '../queries.utils';
import { offeringDividendKeyFn } from './offerings.keys';

export function useOfferingDividendsQuery(
  offeringId?: OfferingId,
  options?: UseQueryOptions<OfferingDividend[]>
): UseQueryResult<OfferingDividend[]> {
  return useQuery(offeringDividendKeyFn(offeringId!), async () => getOfferingDividends(offeringId!), {
    ...options,
    staleTime: options?.staleTime ?? MAX_STALE_TIME,
    enabled: (options?.enabled ?? true) && offeringId != null,
  });
}
